/**
 * Simplified lookup service hooks that use auth.js only
 * The auth service automatically handles v1/v2 conditional transformation
 */

import * as LOCAL_STORAGE_KEYS from 'shared/constants/localStorageKeys';
import {
  useGetCitiesQuery,
  useGetEducationLevelsQuery,
  useGetEmploymentCategoriesQuery,
  useGetEmploymentSectorsQuery,
  useGetFamilySizeQuery,
  useGetMaritalStatusLookupQuery,
  useGetNationalitiesQuery,
  useGetOccupationsQuery,
  useGetRegionsQuery,
  useGetRelatedPartyQuery,
  useGetResidentialStatusQuery,
  useGetTitlesQuery,
} from './auth';

/**
 * Get the upgrade flag from localStorage
 * @returns {boolean} true if upgrade flag is set to true, false otherwise
 */
export const getUpgradeFlag = () => {
  try {
    const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.USER));
    return user?.upgrade === true;
  } catch (error) {
    console.error("Error parsing user data from localStorage:", error);
    return false;
  }
};

/**
 * Utility function to get the current API version being used
 * @returns {string} 'v1' or 'v2'
 */
export const getCurrentApiVersion = () => {
  return getUpgradeFlag() ? 'v2' : 'v1';
};

// Re-export all lookup hooks from auth.js
// These hooks now handle conditional transformation internally
export {
  useGetCitiesQuery, useGetEducationLevelsQuery, useGetEmploymentCategoriesQuery, useGetEmploymentSectorsQuery, useGetFamilySizeQuery, useGetMaritalStatusLookupQuery, useGetNationalitiesQuery, useGetOccupationsQuery, useGetRegionsQuery, useGetRelatedPartyQuery, useGetResidentialStatusQuery, useGetTitlesQuery
};

